import React from "react";
import { Pagination } from "react-bootstrap";

/** Paginación simple (anterior/siguiente + "Página X de Y"), usada en listas con muchos registros. */
export default function PaginacionSimple({ pagina, totalPaginas, onChange }) {
  if (totalPaginas <= 1) return null;

  return (
    <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap gap-2">
      <div className="text-muted small">Página {pagina} de {totalPaginas}</div>
      <Pagination className="mb-0">
        <Pagination.Prev disabled={pagina <= 1} onClick={() => onChange(pagina - 1)} />
        <Pagination.Next disabled={pagina >= totalPaginas} onClick={() => onChange(pagina + 1)} />
      </Pagination>
    </div>
  );
}
